<template>
    <div class="product-promo" v-if="product.promo_code">
        <div v-if="!applied">
            <span class="product-promo-text">
                Дополнительная скидка {{ product.promo_code.discount }} по промо коду {{ product.promo_code.code }}
            </span>

            <div class="product-promo-apply">
                <div class="product-promo-timer">
                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_1103_16)">
                            <path d="M13.5634 12.4661L10.7748 10.3747V6.11445C10.7748 5.68609 10.4286 5.33984 10.0002 5.33984C9.57184 5.33984 9.22559 5.68609 9.22559 6.11445V10.762C9.22559 11.006 9.34023 11.2361 9.53543 11.3817L12.6338 13.7055C12.7732 13.8101 12.9359 13.8604 13.0978 13.8604C13.334 13.8604 13.5664 13.7543 13.7182 13.5498C13.9755 13.2082 13.9057 12.7225 13.5634 12.4661Z" fill="#F31B1C"/>
                            <path d="M10 0.700195C4.48566 0.700195 0 5.18586 0 10.7002C0 16.2145 4.48566 20.7002 10 20.7002C15.5143 20.7002 20 16.2145 20 10.7002C20 5.18586 15.5143 0.700195 10 0.700195ZM10 19.151C5.34082 19.151 1.54918 15.3594 1.54918 10.7002C1.54918 6.04102 5.34082 2.24937 10 2.24937C14.66 2.24937 18.4508 6.04102 18.4508 10.7002C18.4508 15.3594 14.6592 19.151 10 19.151Z" fill="#F31B1C"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_1103_16">
                                <rect width="20" height="20" fill="white" transform="translate(0 0.700195)"/>
                            </clipPath>
                        </defs>
                    </svg>
                    <remaining-time :timestamp="product.promo_code.end_time_timestamp" :expanded="true"></remaining-time>
                </div>
                <a class="btn btn-outline" @click.prevent="apply">Применить</a>
            </div>
        </div>
        <div v-if="applied">
            <span class="product-promo-text">Промокод {{ product.promo_code.code }} применён!</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ProductPromoCode',
        props: {
            product: {
                required: true,
                type: Object
            },
            promoCode: {
                type: Object,
            },
        },
        data () {
            return {
                applied: false
            }
        },
        mounted () {
            this.applied = this.product.promo_code && this.product.promo_code.applied;
        },
        methods: {
            apply () {
                let _this = this;

                axios.post('/products/' + _this.product.id + '/apply-promo-code/' + _this.product.promo_code.code)
                    .then(response => {
                        _this.applied = true;
                        _this.$emit('update', response.data.finalPrice);
                    })
                    .catch(error => {
                        console.log('failed');
                        console.log(error);
                    })
            },
        },
    }
</script>
